module.exports = "//static.hsappstatic.net/LoginUI/static-1.13962/img/donut_mobile.svg"